import { SEVERITY_TIER_CONFIG } from "../../types/severity-tier";
import type { StatusBreakdown } from "../../types/shadow-run";
import styles from "./StatusDistributionBar.module.css";

export interface StatusDistributionBarProps {
  breakdown: StatusBreakdown[];
  height?: number;
  indeterminate?: boolean;
}

export function StatusDistributionBar({
  breakdown,
  height = 8,
  indeterminate = false,
}: StatusDistributionBarProps) {
  const nonZeroItems = breakdown.filter((item) => item.percentage > 0);

  if (nonZeroItems.length === 0) {
    if (indeterminate) {
      return (
        <div
          className={styles.bar}
          style={{ height }}
          role="img"
          aria-label="Loading data"
        >
          <div className={styles.indeterminateSegment} />
        </div>
      );
    }

    return (
      <div
        className={styles.bar}
        style={{ height }}
        role="img"
        aria-label="No data"
      >
        <div className={styles.emptySegment} />
      </div>
    );
  }

  const total = nonZeroItems.reduce((sum, item) => sum + item.percentage, 0);

  return (
    <div
      className={styles.bar}
      style={{ height }}
      role="img"
      aria-label="Status distribution"
    >
      {nonZeroItems.map((item) => {
        const config = SEVERITY_TIER_CONFIG[item.tier];
        return (
          <div
            key={item.tier}
            className={styles.segment}
            style={{
              flexGrow: item.percentage / total,
              flexBasis: 0,
              backgroundColor: config.color,
            }}
            title={`${config.label}: ${item.count} (${item.percentage}%)`}
          />
        );
      })}
    </div>
  );
}
